import React, { createContext } from "react";

export const AccessContext = createContext();
